import type { ReactElement } from 'react';
import { Breadcrumbs } from '../components/PublicSiteFrame';
import { GameRow } from '../components/GameRow';
import { GAMES_HOME_PATH } from '../routes';
import type { GamesMostPlayedData } from '../types';

/** The most played games, ranked (`/a/games/most-played`): the home's "See all". */
export function MostPlayedBody({ data }: { data: GamesMostPlayedData }): ReactElement {
  return (
    <div className="fg-wrap">
      <Breadcrumbs trail={[{ label: 'Games', href: GAMES_HOME_PATH }, { label: 'Most played' }]} />
      <header className="fg-banner">
        <h1 className="fg-banner__title">Most played</h1>
        <p className="fg-banner__count">
          {data.games.length > 0
            ? `The ${data.games.length === 1 ? 'game' : `${data.games.length} games`} played most on Fias`
            : 'Nothing has been played yet.'}
        </p>
      </header>
      {data.games.length > 0 && (
        <ol className="fg-list">
          {data.games.map((game, i) => (
            <li key={game.slug}>
              <GameRow game={game} rank={i + 1} iconSize="md" headingLevel={2} />
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
